module.exports = __webpack_public_path__ + "static/media/slide3.f2d0b19c.webp";